import { render, staticRenderFns } from "./BannersBySlider.vue?vue&type=template&id=e1737a0c&scoped=true&"
import script from "./BannersBySlider.vue?vue&type=script&lang=js&"
export * from "./BannersBySlider.vue?vue&type=script&lang=js&"
import style0 from "./BannersBySlider.vue?vue&type=style&index=0&id=e1737a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1737a0c",
  null
  
)

export default component.exports